import { useMemo } from 'react';

import type { AdvocateAvatarProps } from '../../../types';
import { HAS_ADVOCATES_STATE } from '../../../util';

export const useAdvocateInfo = ({ hasAdvocatesState, petitionAdvocates }: AdvocateAvatarProps) => {
	const title = useMemo(() => {
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.none) return 'Community Petition';
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.one) return 'Petition Advocate';
		return 'Petition Advocates';
	}, [hasAdvocatesState]);

	const subtitle = useMemo(() => {
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.none) return 'Petition Starter';

		const firstAdvocate = petitionAdvocates?.[0];
		if (!firstAdvocate) return '';

		const name = `${firstAdvocate.firstName} ${firstAdvocate.lastInitial}`;
		if (hasAdvocatesState === HAS_ADVOCATES_STATE.one) return name;

		const othersCount = petitionAdvocates.length - 1;
		return `${name} and ${othersCount} others`;
	}, [hasAdvocatesState, petitionAdvocates]);

	return { title, subtitle };
};
